// blue主题：用于归一化、试听课
import blue_keyboardbg from '../../assets/blue/keyboardbg.svg';
import blue_close from '../../assets/blue/close.svg';
import blue_ipadClose from '../../assets/blue/ipad-close.svg';
import blue_ipadDelete from '../../assets/blue/ipad-delete.svg';
import blue_ipadCapsLock from '../../assets/blue/ipad-capsLock.svg';
import blue_closeHover from '../../assets/blue/close-hover.svg';
import blue_closeClick from '../../assets/blue/close-click.svg';
import blue_number from '../../assets/blue/number.svg';
import blue_alphabet from '../../assets/blue/alphabet.svg';
import blue_common from '../../assets/blue/common.svg';
import blue_relation from '../../assets/blue/relation.svg';
import blue_geometric from '../../assets/blue/geometric.svg';
import blue_brackets from '../../assets/blue/brackets.svg';
import blue_interval from '../../assets/blue/interval.svg';
import blue_set from '../../assets/blue/set.svg';
import blue_exponent from '../../assets/blue/exponent.svg';
import blue_logarithm from '../../assets/blue/logarithm.svg';
import blue_radical from '../../assets/blue/radical.svg';
import blue_equation from '../../assets/blue/equation.svg';
/*-----待增加--start----*/
import blue_calculus from '../../assets/blue/calculus.svg';
import blue_matrix from '../../assets/blue/matrix.svg';
/*-----待增加--end----*/
import blue_serial from '../../assets/blue/serial.svg';
import blue_unit from '../../assets/blue/unit.svg';
import blue_chemical from '../../assets/blue/chemical.svg';
import blue_script from '../../assets/blue/script.svg';
import blue_numerals from '../../assets/blue/numerals.svg';
import blue_chinese from '../../assets/blue/chinese.svg';
import blue_uppercase from '../../assets/blue/uppercase_bak.svg';
import blue_lowercase from '../../assets/blue/lowercase_bak.svg';
import blue_scrollarray from '../../assets/blue/scrollarray.svg';
import blue_arrowleft from "../../assets/blue/arrowleft.svg";
import blue_arrowright from "../../assets/blue/arrowright.svg";

// simple主题：用于大部分学习系统
import simple_keyboardbg from '../../assets/simple/keyboardbg.svg';
import simple_close from '../../assets/simple/close.svg';
import simple_ipadClose from '../../assets/simple/ipad-close.svg';
import simple_ipadDelete from '../../assets/simple/ipad-delete.svg';
import simple_delete from '../../assets/simple/ipad-delete.svg';
import simple_hwr from "../../assets/simple/ipad-hwr.svg";
import simple_kb from "../../assets/simple/ipad-kb.svg";
import simple_more from '../../assets/simple/more.svg';
import simple_ipadCapsLock from '../../assets/simple/ipad-capsLock.svg';
import simple_closeHover from '../../assets/simple/close-hover.svg';
import simple_closeClick from '../../assets/simple/close-click.svg';
import simple_number from '../../assets/simple/number.svg';
import simple_alphabet from '../../assets/simple/alphabet.svg';
import simple_common from '../../assets/simple/common.svg';
import simple_relation from '../../assets/simple/relation.svg';
import simple_geometric from '../../assets/simple/geometric.svg';
import simple_brackets from '../../assets/simple/brackets.svg';
import simple_interval from '../../assets/simple/interval.svg';
import simple_set from '../../assets/simple/set.svg';
import simple_exponent from '../../assets/simple/exponent.svg';
import simple_logarithm from '../../assets/simple/logarithm.svg';
import simple_radical from '../../assets/simple/radical.svg';
import simple_equation from '../../assets/simple/equation.svg';
/*-----待增加--start----*/
import simple_calculus from '../../assets/simple/calculus.svg';
import simple_matrix from '../../assets/simple/matrix.svg';
/*-----待增加--end----*/
import simple_serial from '../../assets/simple/serial.svg';
import simple_unit from '../../assets/simple/unit.svg';
import simple_chemical from '../../assets/simple/chemical.svg';
import simple_script from '../../assets/simple/script.svg';
import simple_numerals from '../../assets/simple/numerals.svg';
import simple_chinese from '../../assets/simple/chinese.svg';
import simple_uppercase from '../../assets/simple/uppercase_bak.svg';
import simple_lowercase from '../../assets/simple/lowercase_bak.svg';
import simple_scrollarray from '../../assets/simple/scrollarray.svg';
import simple_arrowleft from "../../assets/simple/arrowleft.svg";
import simple_arrowright from "../../assets/simple/arrowright.svg";

const Theme = {
    simple: {
        keyboard: simple_keyboardbg,
        close: simple_close,
        closeClick: simple_closeClick,
        closeHover: simple_closeHover,
        number: simple_number,
        alphabet: simple_alphabet,
        common: simple_common,
        relation: simple_relation,
        geometric: simple_geometric,
        brackets: simple_brackets,
        interval: simple_interval,
        set: simple_set,
        exponent: simple_exponent,
        logarithm: simple_logarithm,
        radical: simple_radical,
        equation: simple_equation,
        /*-----待增加--start----*/
        calculus: simple_calculus,
        matrix: simple_matrix,
        /*-----待增加--end----*/
        serial: simple_serial,
        unit: simple_unit,
        chemical: simple_chemical,
        script: simple_script,
        numerals: simple_numerals,
        chinese: simple_chinese,
        lowercase: simple_lowercase,
        uppercase: simple_uppercase,
        ipadDelete: simple_ipadDelete,
        hwr: simple_hwr,
        kb: simple_kb,
        delete: simple_delete,
        more: simple_more,
        ipadClose: simple_ipadClose,
        ipadBackspace: simple_ipadDelete,
        ipadCapsLock: simple_ipadCapsLock,
        scrollarray: simple_scrollarray,
        arrowLeft: simple_arrowleft,
        arrowRight: simple_arrowright,
    },
    blue: {
        keyboard: blue_keyboardbg,
        close: blue_close,
        closeClick: blue_closeClick,
        closeHover: blue_closeHover,
        number: blue_number,
        alphabet: blue_alphabet,
        common: blue_common,
        relation: blue_relation,
        geometric: blue_geometric,
        brackets: blue_brackets,
        interval: blue_interval,
        set: blue_set,
        exponent: blue_exponent,
        logarithm: blue_logarithm,
        radical: blue_radical,
        equation: blue_equation,
        /*-----待增加--start----*/
        calculus: blue_calculus,
        matrix: blue_matrix,
        /*-----待增加--end----*/
        serial: blue_serial,
        unit: blue_unit,
        chemical: blue_chemical,
        script: blue_script,
        numerals: blue_numerals,
        chinese: blue_chinese,
        lowercase: blue_lowercase,
        uppercase: blue_uppercase,
        ipadDelete: blue_ipadDelete,
        hwr: simple_hwr,
        kb: simple_kb,
        delete: simple_delete,
        more: simple_more,
        ipadClose: blue_ipadClose,
        ipadBackspace: blue_ipadDelete,
        ipadCapsLock: blue_ipadCapsLock,
        scrollarray: blue_scrollarray,
        arrowLeft: blue_arrowleft,
        arrowRight: blue_arrowright,
    }
}

export default Theme;